import { render, staticRenderFns } from "./LoadingBase.vue?vue&type=template&id=f2ebbab6&"
import script from "./LoadingBase.vue?vue&type=script&lang=js&"
export * from "./LoadingBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports